module.exports = __webpack_public_path__ + "static/media/email.13a238cf.svg";